import React from "react";
import "./Footer.scss";
import { withRouter } from "react-router-dom";

const ContactSection = (props) => {
  return (
    <div className="ContactSection">
      <div className="content">
        <div className="about">
          <h3>About</h3>
          <p>
            BleepSleep is online platform for Purchasing the best products like
            beds, mattressess, chothes e.t.c... We Offer the best service in Uk.{" "}
            {"  "}
            <span className="learn-more">Learn More...</span>
          </p>
        </div>

        <div className="navigations">
          <h3>Navigations</h3>

          <p
            onClick={() => {
              props.history.push("/catagories");
              window.scrollTo(0, 0);
            }}
            className="navigation"
          >
            Catagories
          </p>
          <p className="navigation">About Us</p>
          <p className="navigation">Contact Us</p>
        </div>

        <div className="follow-us">
          <h2>Follow Us</h2>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="#about"
            className="fa fa-facebook footer-link"
          >
            {" "}
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="#about"
            className="fa fa-instagram footer-link"
          >
            {" "}
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="#about"
            className="fa fa-twitter footer-link"
          >
            {" "}
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="#about"
            className="fa fa-youtube footer-link"
          >
            {" "}
          </a>
        </div>
      </div>

      <div className="footer">
        <p>Copyright &copy; 2021 All rights reserved</p>
      </div>
    </div>
  );
};

export default withRouter(ContactSection);
